import { render, staticRenderFns } from "./viewNutritionReport.vue?vue&type=template&id=302711e3"
import script from "./viewNutritionReport.vue?vue&type=script&lang=js"
export * from "./viewNutritionReport.vue?vue&type=script&lang=js"
import style0 from "./viewNutritionReport.vue?vue&type=style&index=0&id=302711e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports